import { useEffect } from "react";

export default (
  condition: boolean,
  funcWhenEscape: () => void,
  elRef: React.RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleClickOutside = (event: KeyboardEvent) => {
      if (elRef.current && condition && event.key === "Escape") {
        funcWhenEscape();
      }
    };

    document.addEventListener("keydown", handleClickOutside);
    return () => document.removeEventListener("keydown", handleClickOutside);
  }, [condition, funcWhenEscape, elRef]);
};
